// extracted by mini-css-extract-plugin
export default {"header":"style_header__ngN30","title":"style_title__Sk4Dw","form":"style_form__YV5wH","spacer":"style_spacer__mZleS"};